import { render, staticRenderFns } from "./projetcInfo.vue?vue&type=template&id=4300fc9e&scoped=true&"
import script from "./projetcInfo.vue?vue&type=script&lang=js&"
export * from "./projetcInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300fc9e",
  null
  
)

export default component.exports